import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Email = ( { email } ) => {
	return (
		<div>
			<a href={ `mailto:${ email }` }>{ email }</a>
		</div>
	);
};

Email.propTypes = { email: PropTypes.string.isRequired };

export default memo( Email );
